<template>
  <div>
    <div class="text-toolbar"
         v-if="is_visible"
    >

      <v-card color="#263238">
        <v-btn-toggle
            class="text-button-toggle"
            dark

        >
          <v-btn @click="item.align = 'left'"

          >
            <v-icon
                :class="{'success--text':item.align === 'left'}"
            >mdi-format-align-left
            </v-icon>
          </v-btn>

          <v-btn
              @click="item.align = 'center'"
          >
            <v-icon :class="{'success--text':item.align === 'center'}">mdi-format-align-center</v-icon>
          </v-btn>

          <v-btn
              @click="item.align = 'right'"

          >
            <v-icon :class="{'success--text':item.align === 'right'}">mdi-format-align-right</v-icon>
          </v-btn>
          <v-btn color="#263238"
                 @click="item.bold = !item.bold"
                 class="white--text">
            <v-icon
                :class="{'success--text': item.bold}"
            >
              mdi-format-bold
            </v-icon>
          </v-btn>

          <v-btn color="#263238"
                 @click="item.italic = !item.italic"
                 class="white--text">
            <v-icon :class="{'success--text': item.italic}">
              mdi-format-italic
            </v-icon>
          </v-btn>
          <v-btn color="#263238" class="white--text"
                 @click="item.underline = !item.underline"
          >
            <v-icon :class="{'success--text': item.underline}">
              mdi-format-underline
            </v-icon>
          </v-btn>
          <v-btn color="#263238"
                 @click="show_settings = !show_settings"
                 class="white--text">
            <v-icon>
              mdi-cogs
            </v-icon>
          </v-btn>
          <v-btn @click="close_function"
                 color="#263238" class="white--text">
            <v-icon>
              mdi-close-box
            </v-icon>
          </v-btn>
        </v-btn-toggle>
      </v-card>
    </div>

    <blocks-models-text-block
        :is_visible="show_settings"
        :item="item"
        :close_text_settings="close_text_settings"
    ></blocks-models-text-block>
  </div>

</template>
<script>
import BlocksModelsTextBlock from '@/components/Blocks/Models/TextBlock'
export default {
  components: {
    BlocksModelsTextBlock
  },
  props: {
    is_visible: Boolean,
    item: Object,
    close_function: Function,
  },
  data() {
    return {
      show_settings: false,
      show_holder: false,
      color: '#8E00FF',
      hideCanvas: false,
      hideInputs: true,
      hideModeSwitch: true,
      mode: 'hexa',
      modes: ['rgba', 'hsla', 'hexa'],
      showSwatches: false,
      typeface: 1,
      type_faces: [
        {
          id: 1,
          name: 'Arial',
          family: '"Helvetica Neue", Arial, sans-serif'
        }
      ],

    }
  },
  methods: {
    close_text_settings() {
      this.show_settings = false;
    }
  }
}
</script>
<style lang="scss">
.text-toolbar {
  position: absolute;
  top: -40px;
  margin: auto;
  width: 306px !important;
  height: 45px;
  z-index: 90002;

  .v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
    height: 38px;
    min-width: 38px;
  }

  .text-button-toggle .v-btn i {
    font-size: 13px !important;
  }

  .text-button-toggle {

    position: relative;
    z-index: 90002;

    .v-btn {
      height: 35px;
    }
  }

  .text-settings {
    height: 350px;
    top: 0;
    width: 250px;
    position: absolute;
    right: -250px;
    background-color: #263238;

    .inner-settings {
      max-height: 100%;
      overflow: auto;
    }
  }

  .text-settings-right {
    height: 350px;
    top: 0;
    width: 250px;
    position: absolute;
    left: -250px;
    background-color: #263238;

    .inner-settings {
      max-height: 100%;
      overflow: auto;
    }
  }

  .swatch-holder {
    position: absolute;
    height: 137px;
    top: -130px;
    width: 295px;
    background-color: #263238;
  }

  .swatch-holder-bottom {
    position: absolute;
    height: 137px;
    bottom: -130px;
    width: 295px;
    background-color: #263238;
  }

  .text-color {
    width: 30px;
    height: 30px;
    border: 1px solid white;
    border-radius: 40px;
    background-color: #000;
    font-family: "Helvetica Neue", Arial, sans-serif;

    &:hover {
      cursor: pointer;
    }
  }

  .v-color-picker__controls {
    padding: 5px;
  }

  .v-text-field {
    padding-top: 4px;
  }

  .shadow-switch {
    i {
      color: white;
    }
  }
}
</style>
